import { useRef, useCallback } from 'react';

export const useRunOnce = () => {
  const hasRun = useRef(false);

  return useCallback((callback: () => void) => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;
    callback();
  }, []);
};
